import React, { useRef, useState, useEffect } from 'react';
import BurgerIcon from './Burger';
import classnames from 'classnames';

const Hero = () => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const toggleMenu = () => {
    setIsMenuVisible((prev) => {
      document.body.style.overflow = prev ? 'auto' : 'hidden';
      return !prev;
    });
  };

  return (
    <section
      className="bg-[#939ACB] flex flex-row items-center w-full justify-center"
      id="home"
    >
      <div id="container" className="flex flex-col max-w-[1280px] w-full justify-between px-10 mq450:px-4 pt-[176px] pb-[80px] mq450:py-[88px] mq450:pb-[32px]">
        <div className='flex w-full h-full mq450:flex-col gap-[32px]'>
          <div id='left' className='flex flex-col w-full justify-center gap-[32px] mq450:order-2'>
            <div id='top' className='flex flex-col gap-[32px] mq450:gap-[24px]'>
              <div id='title' className='text-[48px] font-silka-semibold font-[500] leading-[120%] text-white mq450:text-[40px]'>
                Codzienny rytułał,<br /> który róbi różnicę!
              </div>
              <div id='text' className='text-[18px] text-white font-silka-semibold font-[300] tracking-[0.05em] leading-[160%] mq450:text-[16px]'>
                Nasze żelki to doskonałe połączenie smaku i zdrowia. Wybierz suplementy, które wspierają Twoje cele zdrowotne!
              </div>
            </div>
            <div id='bts' className='flex flex-row gap-[12px] mq450:flex-col'>
              <div onClick={() => window.open('', '_blank')} className="flex px-[32px] items-center justify-center h-[56px] text-[16px] text-white bg-[#362F5B] rounded-full font-silka-light font-[400] tracking-[0.05em] no-underline cursor-pointer">
                Umów spotkanie
              </div>
              <div onClick={() => window.open('', '_blank')} className="hidden flex px-[32px] items-center justify-center h-[56px] text-[16px] text-[#362F5B] bg-white rounded-full font-silka-light font-[400] tracking-[0.05em] no-underline cursor-pointer">
                Umów spotkanie
              </div>
            </div>
          </div>

          <div id='right' className='flex flex-col w-full justify-center mq450:order-1'>
            <img src='/hero-img.png' className='w-full' alt="Hero" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
